module.exports = __webpack_public_path__ + "img/level-2.8b9a5bd3.png";